import React, { Fragment, useEffect, useState } from "react";
import Login from "./pages/login/Login";
import Otp from "./pages/login/Otp";
import { Route, Routes, useNavigate } from "react-router-dom";
import Properties from "./pages/login/Properties";
import AuthenticationManager from "./services/StorageJWT";
import Answer from "./pages/game/one/Answer";
import Calling from "./components/Calling";
import Calll from "./pages/game/one/Call";
import { AuthProvider, ProtectedRoute } from "./provider/AuthProvider";
import Contacts from "./pages/game/one/Contacts";
import Main from "./pages/game/one/Main";
import Points from "./pages/menu/Points";
import Help from "./pages/game/one/helps/Help";
import Help2 from "./pages/game/two/helps/Help2";
import Menu from "./pages/menu/Menu";
import Profile from "./pages/menu/Profile";
import Games from "./pages/menu/Games";
import Messages from "./pages/menu/Messages";
import Open from "./pages/game/one/Open";
import Home from "./pages/game/one/Home";
import Assist from "./pages/menu/Assist";
import Code from "./pages/menu/Code";
import Main2 from "./pages/game/two/Main2";
import Select from "./pages/game/Select";

function App() {
  const [mobile, setMobile] = useState("");
  const _auth = new AuthenticationManager();
  const navigate = useNavigate();
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/"
          // Component={Login}
          Component={(props) => {
            if (_auth.getAccessToken() === "")
              return <Login setMobile={setMobile} mobile={mobile} />;
            else if (_auth._user.active_game === "game2") {
             return document.location.href="/two"
            } else if (_auth._user.active_game === "game1") {
              return  document.location.href="/one"
              
            } else {
              _auth.logout();
              return <Login />;
            }
          }}
        />
        <Route
          path="/one/check"
          // Component={Login}
          Component={(props) => {
            if (_auth.getAccessToken() === "")
              return <Login setMobile={setMobile} mobile={mobile} />;
            else if (_auth._user.status == 2) return <Home />;
            else if (_auth._user.status == 1) return <Main />;
            else if (_auth._user.status == 1.1) return <Home />;
            else if (_auth._user.status == 0) return <Properties />;
            // else {
            //   _auth.logout();
            //   return <Login/>
            // }
          }}
        />
        <Route path="otp" Component={Otp} />
        <Route path="properties" Component={Properties} />
        <Route
          path="two"
          element={
            <ProtectedRoute>
              <Main2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="two/helps"
          element={
            <ProtectedRoute>
              <Help2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="one"
          element={
            <ProtectedRoute>
              <Main />
            </ProtectedRoute>
          }
        />
        <Route
          path="one/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="one/helps"
          element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          }
        />
        <Route
          path="one/answer"
          element={
            <ProtectedRoute>
              <Answer />
            </ProtectedRoute>
          }
        />
        <Route
          path="one/open"
          element={
            <ProtectedRoute>
              <Open />
            </ProtectedRoute>
          }
        />

        <Route
          path="one/contacts"
          element={
            <ProtectedRoute>
              <Contacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="one/call"
          element={
            <ProtectedRoute>
              <Calll />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="menu"
          element={
            <ProtectedRoute>
              <Menu />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/games"
          element={
            <ProtectedRoute>
              <Games />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/games/code"
          element={
            <ProtectedRoute>
              <Code />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/points"
          element={
            <ProtectedRoute>
              <Points />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/assist"
          element={
            <ProtectedRoute>
              <Assist />
            </ProtectedRoute>
          }
        />
        <Route
          path="menu/messages"
          element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
